<!--视频文章详情-->
<template>
  <div class="video-container">
    <headerIndex/>
    <div class="video-content">
      <div class="player-container">
        <video-player class="video-player vjs-custom-skin" :playsinline="true" ref="videoPlayer" :options="playerOptions"/>
      </div>
      <!-- 工具栏 -->
      <div class="video-tools">
        <div class="left">
          <div class="item" @click="articleFabulousMethod">
            <img src="@/assets/img/home/zan.png" v-if="details.is_fabulous == 0" class="zan"/>
            <img src="@/assets/img/home/zan1.png" v-else class="zan"/>
            <span>{{ details.fabulous_count }}</span>
          </div>
          <div class="item" @click="commentCollectionMethod">
            <img src="@/assets/img/home/like.png" class="zan" v-if="details.is_collection == 0"/>
            <img src="@/assets/img/home/like1.png" class="zan" v-else/>
            <span>收藏</span>
          </div>
          <div class="item copyBtn" :data-clipboard-text="details.content" @click="onCopy">
            <i class="iconfont icon-fenxiang"/>
            <span>分享</span>
          </div>
          <div class="item" @click="openReport">
            <img src="@/assets/img/home/danger.png" class="zan"/>
            <span>举报</span>
          </div>
        </div>
        <div class="more">
          {{ details.view }}次播放 | 发布时间：{{ details.time }}
        </div>
      </div>
      <p class="video-name SourceHanSansCN">{{ details.title }}</p>
      <!-- 用户信息 -->
      <div class="user-info">
        <div class="user-logo" @click="authorPage(details.bid)">
          <el-image style="width: 50px; height: 50px;border-radius: 50%;" :src="details.user_avatar"/>
        </div>
        <div class="userTips" @click="authorPage(details.bid)">
          <div class="username SourceHanSansCN">{{ details.user_name }}</div>
          <div class="releaseTime">{{ details.fens_count }}粉丝 · {{ details.article_count }}视频</div>
        </div>
        <div class="own_red_button" @click="editFollowMethod">
          {{ details.is_follow == 0 ? "关注" : "已关注" }}
        </div>
      </div>
      <!-- 猜你喜欢 -->
      <div class="likeVideo">
        <p style="display: flex; justify-content: space-between">
          <span class="head SourceHanSansCN">猜你喜欢</span>
          <span class="refresh-btn" @click="getRecommend"><i class="el-icon-refresh"/>换一批</span>
        </p>
        <div class="video-list u-flex u-row-between">
          <div class="video-item" v-for="(item, index) in recommend" :key="index" @click="refresh(item)"
               :style="index==0 ? 'padding-left: 0px;' : 'padding-left: 20px;'">
            <el-image style="width: 100%; height: 220px; border-radius: 6px" :src="item.image" fit="cover"/>
            <p class="title">{{ item.title }}</p>
            <div class="u-flex" style="margin-top: 10px;">
              <el-avatar :src="item.user_avatar" :size="28" @click.stop="$router.push('/AuthorPage/' + item.bid)"/>
              <span style="color: #333; margin-left: 10px" @click.stop="$router.push('/AuthorPage/' + item.bid)"
                    class="red_name">{{ item.user_name }}</span>
              <span style="color: #999; margin-left: 20px">{{ item.view }}次播放·{{ item.time }}</span>
            </div>
          </div>
        </div>
      </div>
      <!-- 发布评论 -->
      <div class="pushComment">
        <p class="push-title SourceHanSansCN">发表评论</p>
        <el-input type="textarea" :rows="5" placeholder="" maxlength="600" show-word-limit
                  v-model="textarea"></el-input>
        <el-popover placement="top-start" width="400" v-model="toggleEmoji">
          <div class="emojiList">
            <span v-for="row in emoji" :key="row" @click="addEmoji(row)">{{ row }}</span>
          </div>
          <div class="mask" @click="toggleEmoji = false"/>
          <i class="expression" slot="reference"/>
        </el-popover>
        <div class="u-flex u-row-between" style="padding-top: 10px">
          <div></div>
          <el-button type="primary" round @click="pinglun" style="float: right">发表</el-button>
        </div>
      </div>
      <commentList :commentArray="commentArray" :details="details" @reply="reply" :total="total"
                   @dianzan="getCommentList" @showMore="showMore"/>
      <!-- 分页 -->
      <page :total="total" class="pagination" @currentPage="changePage"/>
    </div>
    <home_footer/>
    <report ref="report" title="举报文章问题" type="2" :article_id="details.id"/>
    <hang/>
  </div>
</template>

<script>
import headerIndex from "@/components/header/headerIndex";
import page from "@/components/page/pages";
import Hang from "@/components/Hang/Hang";
import commentList from "@/components/media/commentList";
import report from "@/components/media/report";
import emoji from "@/common/emoji"
import {
  articleInfo,
  commentNewList,
  editFollow,
  commentCollection,
  articleFabulous,
  commentAdd,
  articleInfoRecommend
} from '@/api/interfaceApi'
import Home_footer from "@/components/footer/home_footer";
export default {
  name: "videoDetails",
  components: {Home_footer, headerIndex, page, commentList, Hang, report},
  data() {
    return {
      details: {},
      recommend: [], //相关视频
      textarea: "",
      commentArray: [], //评论列表
      saveArry: [], //保存的完整评论列表
      page: 1,
      total: 0,
      player: null,
      playerOptions:{
        language: "zh-CN",
        autoplay: false,
        controls: true,
        loop: false,
        muted: false,
        aspectRatio: "16:9",
        playbackRates: [0.5, 1.0, 1.5, 2.0],
        preload: "auto",
        fluid: true,
        techOrder: ['html5'],
        sources: [{
          type: ["video/mp4"],
          src: ''
        }],
        flash: {hls: {withCredentials: false}},
        html5: {hls: {withCredentials: false}},
        poster:'',
        notSupportedMessage: "此视频暂无法播放，请稍后再试",
        hls: true,
        controlBar: {
          timeDivider: true,
          durationDisplay: true,
          remainingTimeDisplay: true,
          fullscreenToggle: true,
        }
      },
      emoji,
      showEmoji: 'none',
      toggleEmoji: false,
      id: 0,
      type: 1,
      cid: 0,
    }
  },
  methods: {
    //获取详情
    getArticleInfo() {
      articleInfo({
        id: this.$route.query.id,
        type: parseInt(this.$route.query.type) == 2 ? 1 : 1,
        cid: this.cid != 0 && this.cid != undefined ? this.cid : 0,
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0
      }).then((res) => {
        if (res.code == 200) {
          this.details = res.content;
          this.playerOptions.sources[0].src = res.content.content;
          this.playerOptions.poster = res.content.image;
          if (res.content.content.indexOf('m3u8') > -1) {
            this.playerOptions.sources[0].type = "application/x-mpegURL";
          } else {
            this.playerOptions.sources[0].type = "video/mp4";
          }
        }
      })
    },
    /*获取相关推荐*/
    getRecommend() {
      articleInfoRecommend({
        page: 1, type: 0,
        cid: this.cid != 0 && this.cid != undefined ? this.cid : 0,
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0
      }).then(res => {
        if (res.code == 200) {
          this.recommend = res.content;
        }
      })
    },
    //获取评论列表
    getCommentList() {
      commentNewList({
        aid: parseInt(this.id),
        page: this.page,
        pid: 0,
        type: parseInt(this.type) == 2 ? 1 : parseInt(this.type),
        cid: this.cid != 0 && this.cid != undefined ? this.cid : 0,
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0
      }).then((res) => {
        if (res.code == 200) {
          this.commentArray = res.content.data;
          this.saveArry = JSON.parse(JSON.stringify(res.content.data));
          this.total = res.content.total;
        }
      });
    },
    // 关注视屏
    editFollowMethod() {
      let a = JSON.parse(sessionStorage.getItem('loginData')).cid;
      if (a) {
        let obj = {bid: this.details.bid, uid: JSON.parse(sessionStorage.getItem('loginData')).cid};
        editFollow(obj).then((res) => {
          if (res.code == 200) {
            if (this.details.is_follow) {
              this.$message.success(res.msg);
              this.details.is_follow = 0
              this.details.fens_count -= 1
            } else {
              this.$message.success(res.msg);
              this.details.is_follow = 1
              this.details.fens_count += 1
            }
            this.getArticleInfo();
          }
        });
      } else {
        this.$message.error("请登录后操作");
      }
    },
    // 收藏视屏
    commentCollectionMethod() {
      let obj = {
        aid: this.id, type: this.details.type,
        cid: this.cid != 0 && this.cid != undefined ? this.cid : 0,
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0
      };
      commentCollection(obj).then((res) => {
        if (res.code == 200) {
          if (res.content.status) {
            this.$message.success(res.msg)
            this.details.is_collection = 1;
          } else {
            this.$message.success(res.msg)
            this.details.is_collection = 0;
          }
        }
      });
    },
    // 网络请求 视频点赞
    articleFabulousMethod() {
      let obj = {
        aid: this.$route.query.id,
        cid: this.cid != 0 && this.cid != undefined ? this.cid : 0,
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0
      };
      articleFabulous(obj).then((res) => {
        if (res.code == 200) {
          if (res.content.status) {
            this.$message.success('点赞成功!')
            this.details.fabulous_count += 1;
            this.details.is_fabulous = 1;
          } else {
            this.$message.success('取消点赞成功!')
            this.details.fabulous_count -= 1;
            this.details.is_fabulous = 0;
          }
        }
      });
    },
    //打开视频举报页面
    openReport() {
      if (sessionStorage.getItem('loginData')) {
        this.$refs.report.open();
      } else {
        this.$message.error('请先登录账号')
      }
    },
    oncloseReport() {
      this.$refs.report.close();
    },
    //重新载入页面
    refresh(item) {
      /*文章类型（1：文章， 2：视频 ,3:横版大图（广告模式下使用）,4:小图（广告模式下使用））*/
      if (item.type == 2) {
        let routeData = this.$router.resolve({
          name: "videoDetails",
          query: {
            id: item.id,
            type: item.type,
          },
          path: '/article/videoDetails',
        });
        window.open(routeData.href, '_blank')
      } else {
        if (item.cid == 0) {
          let routeData = this.$router.resolve({
            name: "articleDetails",
            query: {
              id: item.id,
              type: item.type,
            },
            path: '/article/articleDetails',
          });
          window.open(routeData.href, '_blank')
        } else if (item.method_type == "dynamic") {
          let routeData = this.$router.resolve({
            name: "policyDetails",
            query: {
              id: item.id,
              type: item.type,
            },
            path: '/article/policyDetails',
          });
          window.open(routeData.href, '_blank')
        } else if (item.method_type == "policy") {
          let routeData = this.$router.resolve({
            name: "policyDetails",
            query: {
              id: item.id,
              type: item.type,
            },
            path: '/article/policyDetails',
          });
          window.open(routeData.href, '_blank')
        } else if (item.method_type == "notice") {
          let routeData = this.$router.resolve({
            name: "policyDetails",
            query: {
              id: item.id,
              type: item.type,
            },
            path: '/article/policyDetails',
          });
          window.open(routeData.href, '_blank')
        } else {
          let routeData = this.$router.resolve({
            name: "DynamicDetail",
            query: {
              id: item.id,
              type: item.type,
            },
            path: '/article/DynamicDetail',
          });
          window.open(routeData.href, '_blank')
        }
      }
    },
    // 点击评论
    pinglun() {
      let cid = JSON.parse(sessionStorage.getItem('loginData')).cid;
      if (!cid) {
        this.$message.error("请登录后操作");
      } else {
        if (this.textarea) {
          this.commentAddMethod();
        } else {
          this.$message.error("请输入内容");
        }
      }
    },
    // 回复评论
    reply(obj) {
      this.commentAddMethod(obj.content, obj.id);
    },
    // 点击评论区的 展示更多
    showMore(obj) {
      this.commentArray[obj.index].reply = this.saveArry[obj.index].reply;
    },
    // 点击切换页码
    changePage(val) {
      this.page = val;
    },
    // 网络请求 发布评论
    commentAddMethod(replyContent, replyId) {
      if (this.textarea.length > 600 || (replyContent && replyContent.length > 600)) {
        this.$message.error('字数不能超过600字')
        return
      }
      commentAdd({
        aid: this.id, // 文章id
        pid: replyId || "", // 上级评论id(被回复的顶级评论id)
        replyId: "", // 被@的评论表id（回复里面@某条评论时传）
        type: this.type == 2 ? 1 : this.type,// 类型（1：文章/视频，2：工作动态， 3：政策文件， 4：通知公告）
        content: replyContent || this.textarea, // 评论内容
        cid: this.cid != 0 && this.cid != undefined ? this.cid : 0,
        uid: this.cid != 0 && this.cid != undefined ? this.cid : 0
      }).then((res) => {
        if (res.code == 200) {
          this.$message.success(res.msg);
          this.textarea = "";
          this.getCommentList();
        }
      });
    },
    //在文章后面添加emoji表情
    addEmoji(emoji) {
      setTimeout(() => {
        this.textarea = this.textarea + emoji;
        this.toggleEmoji = false;
      }, 100);
    },
    /*查看用户信息*/
    authorPage(bid) {
      let routeData = this.$router.resolve({
        name: "userInfo",
        query: {bid: bid},
        path: '/userInfo/index',
      });
      window.open(routeData.href, '_blank')
    },
    // 复制成功回调
    onCopy() {
      let clipboard = new this.clipboard('.copyBtn');
      clipboard.on('success', e => {
        this.$message({message: '复制成功,去分享吧！', type: 'success'});
        e.clearSelection();
        clipboard.destroy();
      });
      clipboard.on('error', () => {
        this.$message.error('复制失败，请手动选择复制！');
      })
    }
  },
  watch: {
    page(newVal, oldVal) {
      if (newVal != oldVal) {
        this.getCommentList();
      }
    },
  },
  beforeDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  },
  mounted() {
    this.getCommentList();
    this.getRecommend();
    this.getArticleInfo();
  },
  beforeMount() {
    this.cid = sessionStorage.getItem('loginData') != '' && sessionStorage.getItem('loginData') != null && sessionStorage.getItem('loginData') != undefined ? JSON.parse(sessionStorage.getItem('loginData')).cid : 0;
    this.id = this.$route.query.id;
    this.type = this.$route.query.type;
  }
}
</script>

<style scoped lang="scss">
.video-container {
  background: #ffffff;

  .video-content {
    min-width: 76rem;
    background: #ffffff;
    margin: auto;
    padding: 50px 18% 0px;

    .video-name {
      font-size: 24px;
      font-weight: 500;
      color: #333333;
    }
  }

  .video-tools {
    width: 100%;
    background-color: #222;
    height: 42px;
    box-sizing: border-box;
    padding: 0 30px;
    display: flex;
    align-items: center;
    color: #fff;
    justify-content: space-between;
    font-size: 14px;

    .left {
      display: flex;
      align-items: center;

      .item {
        display: flex;
        align-items: center;
        cursor: pointer;
        margin-right: 40px;

        .icon-fenxiang {
          font-size: 16px;
          padding-right: 5px;
          padding-top: 2px;
        }

        img {
          height: 15px;
        }

        span {
          padding-left: 7px;
        }
      }
    }

    .more {
      color: #999;
    }
  }

  .user-info {
    min-height: 90px;

    .user-logo {
      width: 38pt;
      height: 38pt;
      float: left;
      margin-top: 20px;
      cursor: pointer;
    }

    .userTips {
      float: left;
      padding-left: 10pt;
      margin-top: 20px;
      cursor: pointer;

      .username {
        font-size: 18px;
        font-weight: 600;
        color: #555555;
      }

      .releaseTime {
        float: left;
        font-size: 14px;
        padding-top: 5pt;
        color: #999999;
      }
    }

    .own_red_button {
      display: inline-block;
      width: 90px;
      height: 40px;
      line-height: 40px;
      text-align: center;
      background: #fe273b;
      border-radius: 24px;
      cursor: pointer;
      font-size: 16px;
      font-weight: 500;
      color: #ffffff;
      margin-top: 15px;
      float: right;
    }
  }

  .pushComment {
    .push-title {
      font-size: 18px;
      font-weight: bold;
      margin-bottom: 20px;
    }
  }

  .likeVideo {
    .head {
      font-size: 18px;
      font-weight: 600;
      color: #555555;
    }

    .video-list {
      margin-top: 20px;
      display: flex;

      .video-item {
        width: 32%;
        cursor: pointer;
        float: left;
        padding-bottom: 20px;

        .title {
          font-size: 16px;
          color: #333;
          margin-block-start: 0em;
          margin-block-end: 0em;
          padding: 10px 0px;
          overflow: hidden;
          max-height: 35px;
          /*  超出的文本隐藏 */
          display: -webkit-box;
          /* 将对象作为弹性伸缩盒子模型显示。 */
          -webkit-line-clamp: 2;
          /* 这个属性不是css的规范属性，需要组合上面两个属性，表示显示的行数。 */
          -webkit-box-orient: vertical;
          /* 从上到下垂直排列子元素（设置伸缩盒子的子元素排列方式） */
        }

        .u-flex {
          display: flex;
        }
      }
    }

    .refresh-btn {
      cursor: pointer;
      background: #F1F1F1;
      padding: 0px 20px;
      border-radius: 24px;
      line-height: 36px;
    }
  }

  .red_name {
    &:hover {
      color: #FE273B !important;
    }
  }
}
</style>
<style scoped>
.pushComment >>> .el-button--primary {
  color: #FFF;
  background-color: #0067DD;
  border-color: #0067DD;
  padding: 10px 25px;
}

.pushComment >>> .el-textarea__inner {
  background-color: #F1F1F1;
  resize: none;
  border-radius: 12px;
  font-size: 16px;
  color: #333333;
}

.emojiList {
  width: 520px;
  height: 300px;
  overflow: auto;
  background-color: white;
  text-align: justify;
  align-items: center;
  flex-wrap: wrap;
  z-index: 9999;
  padding: 0 10px 10px 0px;
}

.emojiList >>> span {
  font-size: 20px;
  cursor: pointer;
  width: 58px;
  margin: 10px 5px;
}

.expression {
  background: url("~@/assets/img/biaoqing.png") no-repeat;
  width: 20px;
  height: 20px;
  background-size: 100% 100%;
  float: left;
  margin-top: 15px;
}
</style>